module.exports = __webpack_public_path__ + "static/media/settings.7a69da8f.svg";